/**
 * Utility functions for localStorage persistence
 */

/**
 * Load data from localStorage with error handling
 * @param {string} key - The key to retrieve from localStorage
 * @param {T} defaultValue - The default value to return if the key doesn't exist or there's an error
 * @returns {T} The parsed value from localStorage or the defaultValue
 */
export const loadFromLocalStorage = <T>(key: string, defaultValue: T = null as unknown as T): T => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error loading ${key} from localStorage:`, error);
    return defaultValue;
  }
};

/**
 * Save data to localStorage with error handling
 * @param {string} key - The key to store the value under in localStorage
 * @param {any} value - The value to store (will be JSON stringified)
 * @returns {boolean} True if the value was successfully saved to localStorage
 */
export const saveToLocalStorage = <T>(key: string, value: T): boolean => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error(`Error saving ${key} to localStorage:`, error);
    return false;
  }
};
